import { Helmet } from 'react-helmet-async';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';

export default function BrandShieldKoBiddingManualMaxCpc() {
  return (
    <>
      <Helmet>
        <title>Max CPC</title>
      </Helmet>

      <KeywordBased />
    </>
  );
}
